import axios from 'axios';
import { toast } from 'sonner';

/** The 401 the API sends when a live session belongs to a deactivated account. */
export function isAccountDeactivatedError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  if (error.response?.status !== 401) return false;
  const code = (error.response.data as { code?: unknown } | undefined)?.code;
  return code === 'ACCOUNT_DEACTIVATED';
}

/**
 * Explains the sign-out. Shown at once rather than on the login page, which
 * may already be up before the refusing request returns. The fixed id keeps
 * several refused requests to one toast.
 */
export function showAccountDeactivatedNotice(): void {
  toast.error('Your account has been deactivated. Contact your manager for more information.', {
    id: 'account-deactivated',
    duration: 10_000,
  });
}
